<template>
  <div>
    <saffron
      class="app-external-wrapper"
      :show-network-quality="showNetworkQuality"
      :use-meta="true"
      :show-site-credits="false"></saffron>
    <site-credits>
      <div
        class="padding-inline margin-auto flex-center m:flex-between flex-column m:flex-row flex-middle gap-m m:gap-xl flex-wrap">
        <a class="c-bg" href="https://www.localtimeline.com/" target="_blank">
          {{ tu("ls.credits.localStory") }}
        </a>
        <a
          href="https://saffron-technologies.com"
          target="_blank"
          class="flex flex-center flex-middle gap-s c-gray-2">
          <img
            :src="getDynamicAssetUrl('images/logos/saffron-company-square.png')"
            style="height: 24px; width: 24px" />
          <span>{{
            translateTitleCase("core.siteCredits." + "development")
          }}</span>
        </a>
      </div>
    </site-credits>
  </div>
</template>

<script>
import addWindowScript from "@/client/extensions/composition/addWindowScript";
import SaffronComponent from "@/client/components/Saffron.vue";

export default {
  components: {
    Saffron: SaffronComponent,
  },
  props: {
    layout: {
      type: String,
      default: "default",
    },
    forcedLayout: {
      default: false,
      validator: (value) => typeof value === "string" || value === false,
    },
  },
  setup() {
    let { addScript } = addWindowScript();
    return {
      addScript,
    };
  },
  data() {
    return {
      showNetworkQuality: false,
    };
  },
  async mounted() {

    // if (utilities.isSSR() || !config.isProduction) {
    //    return false;
    // }
    //  let script = this.getAsset("accessibility/accessibility.js");
    if (typeof window === "undefined") {
      return;
    }
    if (config.env !== "production") {
      return;
    }

    window.nagishli_config = {
      language: this.getLocaleShort(),
      widgetColor: "black", // doesnt fully work. we hav ecustom CSS
      widgetPosition: this.isLanguageRtl() ? "left" : "right",
    };

    const baseUrl = window.location.origin;

    await this.addScript("https://code.jquery.com/jquery-3.7.1.min.js");
    this.addScript(`${baseUrl}/accesibility/nagishli.js?v=3.0`);
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["user/isLoggedIn"];
    },
  },
  watch: {
    isLoggedIn: {
      async handler(newVal) {
        await this.$acl.isReadyPromise;
        this.showNetworkQuality = this.$acl.isSuperAdmin;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.global-app-wrapper {
  display: flex;
  flex-direction: column;
  flex: 100vh;
  min-height: 100vh;
}
</style>

<style lang="scss">
#NagishLiCopyrights {
  display: none !important;
}

.nagishli-accessibility-statement {
  display: none !important;
}

#NagishLiTrigger {
  border-radius: var(--border-radius-l) !important;
  background-color: var(--c-lead) !important;
  color: var(--c-bg) !important;
  bottom: calc(var(--base-margin) * 86) !important;


  .nagishli-trigger-icon {
    border-radius: var(--border-radius-l) !important;
    background-color: var(--c-lead) !important;
    color: var(--c-bg) !important;
    height: calc(var(--base-margin) * 40);
    width: calc(var(--base-margin) * 40);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0!important;

    img {
      height: calc(var(--base-margin) * 26);
      width: calc(var(--base-margin) * 26);
    }
  }
}

body .nagishli *,
body nagishli * {
  scrollbar-color: var(--c-lead-2) var(--c-gray) !important;
  scrollbar-width: thin;
}

body .nagishli-menu-header {
  background: linear-gradient(var(--c-lead-4) 0%, var(--c-lead) 100%);

  &:hover {
    background: linear-gradient(
      var(--c-lead-5) 0%,
      var(--c-lead-4) 100%
    ) !important;
  }
}
</style>
